import axios from "axios";
import axiosRetry from 'axios-retry'

axiosRetry(axios, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay
})

const ConfigService = (function () {

    var _logoutUrl;
    var _authUrl;
    var _realmName;
    var _uiClientName;
    var _backendClientName;
    var _maxFileSize;
    var _apiUrl = process.env.VUE_APP_API_FLAG === 'true' ? `${process.env.VUE_APP_API_BASE_URL}` : (location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: ''));

    function _getApiUrl() {
        return _apiUrl
    }

    function _getLogoutUrl() {
        if (!_logoutUrl) {
            _setConfigs().then(config => {
                return _logoutUrl
            })
        }
        return _logoutUrl
    }

    function _getAuthUrl() {
        if (!_authUrl) {
            _setConfigs().then(config => {
                return _authUrl
            })
        }
        return _authUrl
    }

    function _getRealmName() {
        if (!_realmName) {
            _setConfigs().then(config => {
                return _getRealmName
            })
        }
        return _realmName
    }

    function _getUiClientName() {
        if (!_uiClientName) {
            _setConfigs().then(config => {
                return _getUiClientName
            })
        }
        return _uiClientName
    }

    function _getBackendClientName() {
        if (!_backendClientName) {
            _setConfigs().then(config => {
                return _getBackendClientName
            })
        }
        return _backendClientName
    }

    function _getMaxFileSize() {
        if (!_maxFileSize) {
            _setConfigs().then(config => {
                return _getMaxFileSize
            })
        }
        return _maxFileSize
    }

    function _setConfigs() {
        if (process.env.VUE_APP_API_FLAG !== 'true') {
            return axios.get(_apiUrl + `/configs`, {ignoreHeader: true})
                .then((response) => {
                    _authUrl = response.data.authUrl
                    _realmName = response.data.realmName
                    _uiClientName = response.data.uiClientName
                    _backendClientName = response.data.backendClientName
                    _maxFileSize = response.data.maxFileSize
                    _logoutUrl = response.data.logoutUrl
                    _logoutUrl = (location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: ''))
                })
        } else {
            return new Promise((resolve, reject) => {
                _authUrl = `${process.env.VUE_APP_KEYCLOAK_URL}`
                _realmName = `${process.env.VUE_APP_KEYCLOAK_REALM}`
                _uiClientName = `${process.env.VUE_APP_KEYCLOAK_CLIENT}`
                _backendClientName = `${process.env.VUE_APP_API_KEYCLOAK_CLIENT}`
                _maxFileSize = `${process.env.VUE_APP_MAX_FILE_BYTES}`
                _logoutUrl = `${process.env.VUE_APP_KEYCLOAK_LOGOUT_REDIRECT_URI}`
                resolve()
            })
        }
    }

    return {
        getApiUrl: _getApiUrl,
        getLogoutUrl: _getLogoutUrl,
        getAuthUrl: _getAuthUrl,
        getRealmName: _getRealmName,
        getUiClientName: _getUiClientName,
        getBackendClientName: _getBackendClientName,
        getMaxFileSize: _getMaxFileSize,
        setConfigs: _setConfigs,
    }

})();

export default ConfigService;
